<template>
  <input-widget :model="model" :attribute="attribute" type="select2" display-field="${item.value}"
                value-field="value" :items="computedTitles"/>
</template>

<script>
  import InputWidget from "./../components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import i18nHelper from "@/core/services/i18n.service";

  const {mapState} = createNamespacedHelpers('global');

  export default {
    name: "CustomerTitleSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true,
      },
      attribute: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: () => []
      },
      preferredLanguageCode: {
        type: String,
        default: null,
        required: false
      }
    },
    data() {
      return {
        masterLanguage: i18nHelper.getMasterLanguage(),
      }
    },
    computed: {
      ...mapState(['customerTitles']),
      computedTitles() {
        if (!this.customerTitles) {
          return []
        }

        if (this.preferredLanguageCode && this.customerTitles[this.preferredLanguageCode]) {
          return this.customerTitles[this.preferredLanguageCode].map(t => {
            return {'key': t, 'value': t}
          })
        } else if (this.masterLanguage && this.customerTitles[this.masterLanguage.key]) {
          return this.customerTitles[this.masterLanguage.key].map(t => {
            return {'key': t, 'value': t}
          })
        }

        return []
      }
    }
  }
</script>

<style scoped>

</style>